import {Link} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function MasterMenu(){

const MenuCard = ({link,title,icon,color}) => (

<div className="col-xl-3 col-lg-4 col-md-6 mb-4">
<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>
</div>

)

return(

<section className="container-fluid mt-4">

<h5 className="menu-section-title">General Master Setting</h5>

<div className="row">

<MenuCard link="/user-register" title="User Master" icon="fa-solid fa-user" color="#0d6efd"/>
<MenuCard link="/change-password" title="Change Password" icon="fa-solid fa-key" color="#dc3545"/>
<MenuCard link="/add-department" title="Add Department" icon="fa-solid fa-building" color="#20c997"/>
<MenuCard link="/add-template" title="Add Template" icon="fa-solid fa-file-lines" color="#6f42c1"/>
<MenuCard link="/speech" title="Speech" icon="fa-solid fa-microphone" color="#fd7e14"/>
<MenuCard link="/calendar" title="To Do List" icon="fa-solid fa-calendar-check" color="#198754"/>

</div>


<h5 className="menu-section-title">OP Details</h5>

<div className="row">

<MenuCard link="/pat-bill-search" title="Patient Billing Details" icon="fa-solid fa-file-invoice" color="#0d6efd"/>
<MenuCard link="/add-patient" title="New Patient Registration" icon="fa-solid fa-user-plus" color="#20c997"/>
<MenuCard link="/pat-register-search" title="Patients Register Report" icon="fa-solid fa-users" color="#fd7e14"/>

</div>


<h5 className="menu-section-title">OP Billing Masters</h5>

<div className="row">

<MenuCard link="/add-minor-cat" title="OP Billing Category" icon="fa-solid fa-layer-group" color="#0d6efd"/>
<MenuCard link="/add-minor-comp" title="OP Billing Component" icon="fa-solid fa-list" color="#20c997"/>
<MenuCard link="/add-consultant" title="Add Consultant" icon="fa-solid fa-user-doctor" color="#dc3545"/>
<MenuCard link="/add-subcat" title="Add Lab Master" icon="fa-solid fa-vial" color="#6f42c1"/>
<MenuCard link="/add-radio" title="Add Radiology Master" icon="fa-solid fa-x-ray" color="#fd7e14"/>

</div>

</section>

)

}

export default MasterMenu;